import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { addToast } from "@/store/toastSlice";

export const useGlobalToast = () => {
  const dispatch = useDispatch();

  const showToast = useCallback(
    (toastData: {
      message: string;
      type: "success" | "error" | "warning" | "info";
      linkId?: string;
      linkName?: string;
    }) => {
      dispatch(addToast(toastData));
    },
    [dispatch],
  );

  return { showToast };
};

export default useGlobalToast;
